import React, { useState } from "react";
import { DotsThreeIcon, PencilIcon } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function SidebarAssistantItem({
    assistant
}) {

    const [openDropdown, setOpenDropdown] = useState(false);

    return (
        <div
            className="group flex gap-2 items-center w-full p-2 hover:bg-light/30 rounded-sm"
            onMouseLeave={() => setOpenDropdown(false)}
            onBlur={(e) => { if (!e.currentTarget.contains(e.relatedTarget)) setOpenDropdown(false); }}
        >
            <Link to={`/conversations?assistant=${assistant._id}`} className="flex-1 flex items-center gap-2">
                <div className="w-6 h-6 rounded-full bg-light bg-cover bg-center" style={{ backgroundImage: `url(${assistant.image || '/images/assistant-avatar.jpg'})` }}></div>
                {assistant.name}
            </Link>
            <div className="relative opacity-0 group-hover:opacity-100 group-focus-within:opacity-100">
                <button
                    type="button"
                    aria-label="Opzioni assistente"
                    aria-haspopup="menu"
                    aria-expanded={openDropdown}
                    onClick={() => setOpenDropdown(o => !o)}
                    className="touch-target flex items-center justify-center p-1 rounded cursor-pointer hover:bg-black/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow"
                >
                    <DotsThreeIcon size={20} className='fill-black' weight="bold" />
                </button>

                <div role="menu" className="absolute right-0 top-7 rounded-lg shadow-lg w-48 z-[var(--z-dropdown)] bg-white overflow-hidden" style={{ display: openDropdown ? 'block' : 'none' }}>
                    <Link role="menuitem" to={`/assistants/${assistant._id}/edit`} className="flex items-center gap-2 p-3 hover:bg-verylight focus:outline-none focus-visible:bg-verylight">
                        <PencilIcon size={16} className='fill-black' />
                        Modifica assistente
                    </Link>
                </div>
            </div>
        </div>
    )
}